import React from 'react';
import styled from 'styled-components';
import { registry } from '../../core/Registry.js';

const Wrapper = styled.div`
  width: ${props => props.width || '100%'};
  max-width: ${props => props.maxWidth || '500px'};
  margin: ${props => props.align === 'center' ? '0 auto' : (props.align === 'right' ? '0 0 0 auto' : '0')};
  background: var(--glass-1);
  padding: 24px;
  border-radius: var(--radius, 12px);
  border: 1px solid var(--glass-border);
  backdrop-filter: blur(var(--glass-blur, 10px));
  box-shadow: 0 10px 30px rgba(0,0,0,0.1);
`;

const FormTitle = styled.h3`
  margin-top: 0;
  margin-bottom: 20px;
  color: var(--text-primary);
  font-size: 18px;
`;

const FormGroup = styled.div`
  margin-bottom: 15px;
`;

const Label = styled.label`
  display: block;
  margin-bottom: 6px;
  font-size: 12px;
  color: var(--text-secondary);
  font-weight: 500;
`;

const Input = styled.input`
  width: 100%;
  padding: 10px 14px;
  border-radius: 8px;
  border: 1px solid var(--glass-border);
  background: rgba(0,0,0,0.2);
  color: var(--text-primary);
  outline: none;
  font-family: inherit;
  transition: all 0.2s ease;

  &:focus {
    border-color: var(--accent);
    box-shadow: 0 0 0 2px rgba(6,182,212,0.2);
  }
`;

const Textarea = styled.textarea`
  width: 100%;
  padding: 10px 14px;
  border-radius: 8px;
  border: 1px solid var(--glass-border);
  background: rgba(0,0,0,0.2);
  color: var(--text-primary);
  outline: none;
  font-family: inherit;
  min-height: 100px;
  resize: vertical;

  &:focus {
    border-color: var(--accent);
  }
`;

const Button = styled.button`
  width: 100%;
  padding: 12px;
  border-radius: 8px;
  background: linear-gradient(135deg, var(--accent), var(--accent-neon));
  color: #fff;
  font-weight: 600;
  border: none;
  cursor: pointer;
  margin-top: 10px;
  box-shadow: 0 4px 15px var(--accent-glow);
  transition: transform 0.2s;

  &:hover {
    transform: scale(1.02);
  }
`;

const FormWidget = ({ node }) => {
  const title = node.content?.title || 'Kontaktieren Sie uns';
  const btnText = node.content?.btnText || 'Absenden';
  const width = node.style?.desktop?.width || '100%';
  const align = node.style?.desktop?.align || 'center';

  return (
    <Wrapper width={width} align={align}>
      {title && <FormTitle>{title}</FormTitle>}
      <form onSubmit={e => e.preventDefault()}>
        <FormGroup>
          <Label>Name</Label>
          <Input type="text" placeholder="Geben Sie Ihren Namen ein" />
        </FormGroup>
        <FormGroup>
          <Label>E-Mail</Label>
          <Input type="email" placeholder="ihre@email.de" />
        </FormGroup>
        <FormGroup>
          <Label>Nachricht</Label>
          <Textarea placeholder="Wie können wir helfen?" />
        </FormGroup>
        <Button className="tef-bubbles">{btnText}</Button>
      </form>
    </Wrapper>
  );
};

registry.register('contact_form', {
  label: 'Kontakt Formular',
  icon: '✉️',
  category: 'forms',
  defaultContent: {
    title: 'Kontakt aufnehmen',
    btnText: 'Nachricht senden'
  },
  defaultStyle: {
    desktop: { width: '100%', align: 'center' }
  },
  render: FormWidget,
  inspectorControls: [
    {
      tab: 'content',
      groups: [
        {
          title: 'Texte',
          fields: [
            { name: 'content.title', label: 'Formular Titel', type: 'text' },
            { name: 'content.btnText', label: 'Button Text', type: 'text' }
          ]
        }
      ]
    },
    {
      tab: 'style',
      groups: [
        {
          title: 'Layout',
          fields: [
            { name: 'style.desktop.width', label: 'Breite (z.B. 100%, 400px)', type: 'text' },
            { name: 'style.desktop.align', label: 'Ausrichtung', type: 'select', options: [{label:'Links', value:'left'}, {label:'Zentriert', value:'center'}, {label:'Rechts', value:'right'}] }
          ]
        }
      ]
    }
  ]
});
